import TimeSeriesKeyChipColor from './TimeSeriesKeyChipColor';
import styled from 'styled-components';

const TimeSeriesKeyChip = styled.span`
    display: inline-flex;
    align-items: center;
    margin: 0 1em 0.5em 0;
    text-transform: capitalize;
    opacity: ${({ $isEmpty }) => ($isEmpty ? '.5' : '1')};
`;

function TimeSeriesKey({ data, ...props }) {
    if (!(data && data.length)) return null;
    return (
        <div {...props}>
            {data.map(({ id, name, color, timeSeries }) => {
                return (
                    <TimeSeriesKeyChip
                        $isEmpty={!(timeSeries && timeSeries.length)}
                        key={id}
                    >
                        <TimeSeriesKeyChipColor $color={color} />
                        {name}
                    </TimeSeriesKeyChip>
                );
            })}
        </div>
    );
}

export default TimeSeriesKey;
